import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { RichText, Icon } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './engineBoxOccups.js';
import { CSSTransition } from 'react-transition-group';
import EngineRoomInfo from './EngineRoomInfo.jsx';

class EngineBoxOccups extends React.Component {
  static displayName = 'EngineBoxOccups';
  constructor(props) {
    super(props);
    this.cx = props.theme.bind();
  }

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  toggleBox = () => {
    const {
      toggleBox,
    } = this.props.config;


    let toggleBoxFn = toggleBox(null, 'occups')
    return toggleBoxFn
  }

  handleKeyPress = (e) => {
    const { key } = e;

    if (key === 'Enter' || key === ' ') {
      e.preventDefault();
      this.toggleBox()();
    }
  };

  render() {
    const { config, theme } = this.props;

    const {
      /* classes, */
      visibleType,
      occups,
      dropDown,
      modalBreak
    } = config;

    const { classes } = theme.styles



    //Desktop version
    if(!modalBreak){
      //extraFields for portalDesing
      const extraLabelText = theme.theme === 'portalDesign' ? (
        <RichText
            translate={true}
            text={'_%Huéspedes%_'}
            ucFirst={true}
            innerStyle={classes.inputEngineTitle}
          />
      ) : null;

      return (<div onClick={this.toggleBox()} onKeyDown={this.handleKeyPress} className={theme.computedInnerStyle} tabIndex={0} id={'ocupsBox'} role='button'>
        <div className={classes.occupContainer}>
          {extraLabelText}
          <Icon unicodeContent={'e0be'} innerStyle={classes.iconsEngine} />
          <div className={classes.occupsBoxContainer}>
            <EngineRoomInfo occups={occups} />
          </div>
        </div>
      </div>)
    }

    //Not desktop version
    return (<CSSTransition
      in={ visibleType === 'occups' || !dropDown}
      timeout={700}
      mountOnEnter
      unmountOnExit
      classNames={{
        enter: classes.inputEnter,
        enterActive: classes.inputEnterActive,
        exit: classes.inputLeave,
        exitActive: classes.inputLeaveActive
      }}>
      <div onClick={this.toggleBox()} className={[theme.computedInnerStyle].join(' ')} tabIndex={0} id={'ocupsBox'} role='button'>
        <div className={classes.occupContainer}>
          <Icon unicodeContent={'e0be'} innerStyle={classes.iconsEngine} />
          <div className={classes.occupsBoxContainer}>
            <EngineRoomInfo occups={occups} />
          </div>
        </div>
      </div>
    </CSSTransition>)

  }

}

export default compose(
  PropertyManager([
    'visibleType',
    'occups',
    'dropDown',
    'toggleBox',
    'changeOccups',
    'modalBreak'
  ]),
  withThemeJSS({ styleFile, link: true, index: 100 }),
  withContent('i18n')
)(EngineBoxOccups);
